import React, { useEffect, useState, useRef } from 'react';
import "./Secoundheader.css";
import ReCAPTCHA from 'react-google-recaptcha';
import { useNavigate } from 'react-router-dom';
import Aos from 'aos';
import 'aos/dist/aos.css';
import Popupboxx from '../Popupbox/Popupbox';
import { SEND_API } from '../../utils/APIs';
import { RECAPTCHA_SITEKEY } from '../../utils/config';

function Secoundheader() {
    const [captchaValue, setCaptchaValue] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    
    const canvasRef = useRef(null);
    const navigate = useNavigate();

    // Combined Effects Hook: Handles AOS and Canvas Animation Initialization
    useEffect(() => {
        // Initialize AOS animations
        Aos.init({
            duration: 1000,
            once: true,
        });

        // Setup Glass Wave Canvas Animation
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        let animationFrameId;
        let time = 0;

        const resizeCanvas = () => {
            if (canvas && canvas.parentElement) {
                canvas.width = canvas.parentElement.clientWidth;
                canvas.height = canvas.parentElement.clientHeight || window.innerHeight;
            }
        };

        resizeCanvas();
        window.addEventListener("resize", resizeCanvas);

        // Smooth glass wave physics configuration array
        const waves = [
  {
    color: "rgba(59,130,246,0.10)",
    amplitude: 80,
    speed: 0.06, // Increased from 0.0015
    offset: 0,
  },
  {
    color: "rgba(255,255,255,0.25)",
    amplitude: 100,
    speed: 0.04, // Increased from 0.001
    offset: 2,
  },
  {
    color: "rgba(147,197,253,0.12)",
    amplitude: 70,
    speed: 0.07, // Increased from 0.0018
    offset: 4,
  },
  {
    color: "rgba(255,255,255,0.18)",
    amplitude: 90,
    speed: 0.05, // Increased from 0.0012
    offset: 6,
  },
];

        // Draw Background Canvas Linear Gradient
        const drawBackground = () => {
            const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
            gradient.addColorStop(0, "#4f8fc9");
            gradient.addColorStop(0.5, "#dce7ef");
            gradient.addColorStop(1, "#c7f2ee");
            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        };

        // Draw a single math-calculated vector sine wave
        const drawWave = (amplitude, color, speed, offset) => {
            ctx.beginPath();
            ctx.moveTo(0, 0);

            for (let y = 0; y <= canvas.height; y++) {
                const x = Math.sin(y * 0.004 + time * speed + offset) * amplitude + canvas.width * 0.25;
                ctx.lineTo(x, y);
            }

            ctx.lineTo(0, canvas.height);
            ctx.closePath();

            ctx.fillStyle = color;

            // Render soft canvas ambient blur glow
            ctx.shadowBlur = 30;
            ctx.shadowColor = "rgba(255,255,255,0.15)";
            ctx.fill();
        };

        // Recursive 60fps Animation Loop
        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            drawBackground();

            waves.forEach((wave) => {
                drawWave(wave.amplitude, wave.color, wave.speed, wave.offset);
            });

            time += 1;
            animationFrameId = requestAnimationFrame(animate);
        };

        animate();

        // Safe cleanup when component unmounts
        return () => {
            cancelAnimationFrame(animationFrameId);
            window.removeEventListener("resize", resizeCanvas);
        };
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!captchaValue) {
            alert("Please verify the CAPTCHA");
            return;
        }

        setIsLoading(true);

        const formData = new FormData(e.target);
        formData.append("g-recaptcha-response", captchaValue);

        fetch(`${SEND_API}`, {
            method: "POST",
            body: formData,
        })
            .then((response) => response.text())
            .then((msg) => {
                console.log(msg);
                e.target.reset();
                setCaptchaValue(null);
                navigate("/uiux-course-in-chennai/thank-you");
                setIsPopupOpen(false);
            })
            .catch(() => alert("Something went wrong!"))
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
         <section className="header-wrapperr">
            <div className="landing-container" >
                
                {/* Embedded Canvas layer pinned to the background layout wrapper */}
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        overflow: "hidden",
                        zIndex: 0, // Keeps animation layers behind headings and forms
                    }}
                >
                    <canvas
                        ref={canvasRef}
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "block",
                        }}
                    />
                </div>

                {/* Foreground Container View Elements */}
                <div className="hero-content" style={{ position: 'relative', zIndex: 1 }}>

                    {/* Left Section */}
                    <div
                        className="info-section"
                        data-aos="fade-right"
                    >
                        <h1
                            className="main-heading"
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            Advance Your Career with{" "}
                            <span className="highlight">
                                Expert-Led UI/UX
                            </span>{" "}
                            Traning
                        </h1>

                        <p
                            className="sub-heading-text"
                            data-aos="fade-up"
                            data-aos-delay="300"
                        >
                            Become job-ready through real-time learning,
                            personalized mentoring, and hands-on practice.
                        </p>

                        {/* Details Grid */}
                        <div
                            className="details-grid"
                            data-aos="fade-up"
                            data-aos-delay="500"
                        >
                            <div className="detail-box">
                                <span className="detail-title">
                                    Duration:
                                </span>
                                <span className="detail-value">
                                    🕒 Duration : 3-4 Month
                                </span>
                            </div>

                            <div className="detail-box">
                                <span className="detail-title">
                                    Mode of Training:
                                </span>
                                <span className="detail-value">
                                    💻 Classroom & Online
                                </span>
                            </div>
                        </div>

                        {/* Button */}
                        <div
                            className="action-area"
                            data-aos="zoom-in"
                            data-aos-delay="700"
                        >
                            <button
                                className="download-btn"
                                onClick={() => setIsPopupOpen(true)}
                            >
                                Download Now
                            </button>
                        </div>
                    </div>

                    {/* Right Form Section */}
                    <div
                        className="form-section"
                        data-aos="fade-left"
                        data-aos-delay="200"
                    >
                        <div className="form-card">
                            <h2 data-aos="fade-up">
                                Let's talk about your career growth!
                            </h2>

                            <form onSubmit={handleSubmit}>
                                {/* Mobile */}
                                <div
                                    className="input-group"
                                    // data-aos="fade-up"
                                    // data-aos-delay="100"
                                >
                                    <label>Mobile Number</label>
                                    <input
                                        type="tel"
                                        name="phone"
                                        placeholder="Enter 10-digit Mobile Number"
                                        required
                                                  maxLength={10}
                                    />
                                </div>

                                {/* Name */}
                                <div
                                    className="input-group"
                                    // data-aos="fade-up"
                                    // data-aos-delay="200"
                                >
                                    <label>Full Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Your Name"
                                        required
                                    />
                                </div>

                                {/* Email */}
                                <div
                                    className="input-group"
                                    // data-aos="fade-up"
                                    // data-aos-delay="300"
                                >
                                    <label>Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="e.g. yourname@gmail.com"
                                        required
                                    />
                                </div>

                                {/* Hidden Inputs */}
                                <input
                                    type="hidden"
                                    name="subject"
                                    value="Course Enquiry for UI/UX"
                                />
                                <input
                                    type="hidden"
                                    name="message"
                                    value="I am interested"
                                />

                                   {/* Captcha */}
                                    <div className="captcha-container">
                                        <ReCAPTCHA
                                            sitekey={RECAPTCHA_SITEKEY}
                                            onChange={(value) => setCaptchaValue(value)}
                                            className="captcha-box1"
                                        />
                                    </div>

                                {/* Submit */}
                                <button
                                    type="submit"
                                    className="submit-btn"
                                    data-aos="zoom-in"
                                    // data-aos-delay="500"
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Submitting..." : "Submit ➔"}
                                </button>
                            </form>
                        </div>
                    </div>

                </div>
            </div>

            {/* Popup */}
            <Popupboxx
                isOpen={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
            />
            </section>
        </>
    );
}

export default Secoundheader;